/**
 *
 * Asynchronously loads the component for His002
 * Author: Thuantq1
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
